import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/packages/web/layouts/default.vue").then(m => m.default || m))
}